<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" :label="this.$t('Station')" :label-width="60">
				<Select :placeholder="this.$t('Station')" style="width: 120px;" v-model="formInline.StationId">
					<Option :value=0>{{ this.$t('Common.All') }}</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
						{{item.StationName}}
					</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName" :label="this.$t('ChargeRecord.StartMode')" :label-width="70">
				<Select :placeholder="this.$t('ChargeRecord.StartMode')" style="width: 100px;" v-model="formInline.StartMode">
					<Option :value='-1'>{{ this.$t('Common.All') }}</Option>
					<Option :value='0'>{{ $t('ChargeRecord.OfflineChargingCard') }}</Option>
					<Option :value='1'>{{ $t('ChargeRecord.OnlineChargingCard') }}</Option>
					<Option :value='2'>{{ $t('ChargeRecord.LocalVINCode') }}</Option>
					<Option :value='3'>{{ $t('ChargeRecord.OnlineVINCode') }}</Option>
					<Option :value='4'>{{ $t('ChargeRecord.PhysicalButtonStart') }}</Option>
					<Option :value='5'>{{ $t('ChargeRecord.ScreenStart') }}</Option>
					<Option :value='6'>{{ $t('ChargeRecord.LocalScheduledCharging') }}</Option>
					<Option :value='7'>{{ $t('ChargeRecord.PlatformScheduledCharging') }}</Option>
					<Option :value='48'>{{ $t('ChargeRecord.Platform') }}</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" style="width: 180px;" v-model="formInline.OrderNo" :placeholder="this.$t('ChargeRecord.OrderNo')">
				<span slot="prepend">{{ $t('ChargeRecord.OrderNo') }}</span>
				</Input>
			</FormItem>
		
			<FormItem :label="$t('ChargeRecord.SelectTime')" :label-width='70'>
				<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
			</FormItem>
			
			<FormItem>
				<Input type="text" style="width: 150px;" v-model="formInline.EquipmentNo" :placeholder="this.$t('EquipmentNo')">
				<span slot="prepend">{{ $t('EquipmentNo') }}</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{ $t('Common.Search') }}</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">{{ $t('ChargeRecord.ExportFile') }}</Button>
			</FormItem>
		</Form>
		<Table :row-class-name="rowClassName" :columns="columns1" :data="data1" :height="tableHeight" ref="ChargingOrder">
		</Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getChargeRecordUrl" @listData='getDeviceData'></MyPage>
		<echartModal ref="echartModal" curvesName="ChargeRecord"></echartModal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import echartModal from '../../public/CurvesTemplate/ChargingOrderEchart.vue'
	import { formatLocalTime } from "../../../utils/date"

	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		components: {
			echartModal
		},
		data() {
			return {
				getChargeRecordUrl: webapi.base_api_url + '/Order/GetChargeRecord',
				loadingStatus: false,
				//
				params: "", //
				
				SelectStation: "",
				tableHeight: "650",
			
		
				BreadcrumbList: [ this.$t('ordersRecord'), '>>',this.$t('chargeRecord')],
				formInline: {
					StationId: 0,
					OrderNo: '',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
					MemberName: '',
					EquipmentNo: '',
					StartMode: -1
				},
				//Table Title Data
				columns1: [{
						title: this.$t('ChargeRecord.OrderNo'),
						key: 'OrderNo',
						// fixed: 'left',
						width: 265
					},
					{
						title: this.$t('ChargeRecord.StartMode'),
						key: 'StartMode',
						width: 100.,
						render: (h, params) => {
							return h('div',
								this.$options.filters.StartModeDesc(params.row.StartMode) 
							);
						}
					},
					{
						title: this.$t('ChargeRecord.ChargingStartTime'),
						key: 'StartTime',
						width: 160,
						render: (h, params) => {
							return h('div', formatLocalTime(params.row.StartTime))
						}
					},
					{
						title: this.$t('ChargeRecord.ChargingEndTime'),
						key: 'EndTime',
						width: 160,
						render: (h, params) => {
							return h('div', formatLocalTime(params.row.EndTime))
						}
					},
					{
						title: this.$t('ChargeRecord.CardNo'),
						key: 'CardNo',
						width: 150
					},
					{
						title: this.$t('ChargeRecord.ChargeKwh'),
						key: 'ChargeKwh',
						width: 110
					},
					{
						title: this.$t('ChargeRecord.ElecCost'),
						key: 'ElecCost',
						width: 100
					}, {
						title:this.$t('ChargeRecord.ServiceCost'),
						key: 'ServiceCost',
						width: 100
					},
					{
						title: this.$t('ChargeRecord.ChargeCost'),
						key: 'ChargeCost',
						width: 110
					},
					{
						title: this.$t('StationMonitoring.ChargeDuration'),
						key: 'ChargeDuration',
						width: 100,
						render: (h, params) => {
							return h('div', params.row.ChargeDurationDesc);
						}
					},
					{
						title: this.$t('ChargeRecord.BeginSoc'),
						key: 'BeginSoc',
						width: 110
					},
					{
						title: this.$t('ChargeRecord.EndSoc'),
						key: 'EndSoc',
						width: 110
					},
					
					{
						title: this.$t('ChargeRecord.TerminateReason'),
						key: 'TerminateReason',
						width: 150
					},
					
					{
						title: this.$t('ConnectorNo'),
						key: 'ConnectorNo',
						width: 110
					},
					{
						title: this.$t('StationName'),
						key: 'StationName',
						width: 100,
					},
					{
						title: this.$t('Common.Actions'),
						key: 'action',
						align: 'center',
						width: 100,
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('chargeCurves') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("view", params.row.OrderNo)
										}
									}
								},  this.$t('ChargeRecord.ChargingCurve')) : h(),
							]);
						}
					}
				],
				data1: [],
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 220;
			this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				
				let param = _this.formInline;
				param.TimeBegin = _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(new Date(_this
					.formInline.TimeBegin), 'yyyy-MM-dd');
				param.TimeEnd = _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(new Date(_this.formInline
					.TimeEnd), 'yyyy-MM-dd');
				return param
			},
			
			...mapState({
				StationList: 'Stations'
			})
		},
		watch: {},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("date change：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			},
			exportFile: function() {
				this.$refs.ChargingOrder.exportCsv({
					filename: this.$t('ChargeRecord.ChargeRecord'),
					data: this.data1.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						// k.OrderTime = '\t' + (k.OrderTime || '');
						k.StartTime = '\t' + (k.StartTime || '');
						k.EndTime = '\t' + (k.EndTime || '');
						// k.RefundTime = '\t' + (k.RefundTime || '');
						return k;
					})
				})
			},
			rowClassName: function(row, index) {
				if (index % 2 == 0) {
					return 'demo-table-info-row';
				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},
			
			show: function(type, params) {
				const _this = this
				switch (type) {
					case "view":
						_this.$refs.echartModal.show(type, params)
						break;
					default:
						break;
				}
			},
			
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220 - (window.innerWidth < 1388 ? 60 : 0);
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
